module.exports = __webpack_public_path__ + "img/upload.870b9142.svg";